module.exports = __webpack_public_path__ + "img/momo_button_load_more.ecf21691.png";